<mat-card appearance="outlined">
  <mat-card-header>
    <img mat-card-avatar [src]="webchatIcon" alt="avatar" />
    <mat-card-title class="title">
      {{ webchat()?.name ? webchat()?.name : ('INBOX.WEBCHAT.SETTINGS.TITLE' | translate) }}
    </mat-card-title>
    <div class="badge">
      <glxy-badge *ngIf="webchat()?.isEnabled" [color]="'green'">{{ 'INBOX.SETTINGS.ACTIVE' | translate }}</glxy-badge>
      <glxy-badge *ngIf="!webchat()?.isEnabled && created" [color]="'grey'">
        {{ 'INBOX.WEBCHAT.SETTINGS.NOT_ACTIVE' | translate }}
      </glxy-badge>
      <glxy-badge *ngIf="created === false" [color]="'red'">
        {{ 'INBOX.WEBCHAT.SETTINGS.SETUP_REQUIRED' | translate }}
      </glxy-badge>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="statement">
      {{ 'INBOX.WEBCHAT.SETTINGS.DESCRIPTION' | translate }}
      <a (click)="learnMore()">{{ 'INBOX.WEBCHAT.SETTINGS.LEARN_MORE' | translate }}</a>
    </div>
    <div class="toggle-container" *ngIf="created">
      <mat-slide-toggle [checked]="webchat()?.isEnabled" (change)="handleToggleChange()"></mat-slide-toggle>
      <div class="toggle-description">
        {{ 'INBOX.WEBCHAT.SETTINGS.ENABLED_WEBCHAT' | translate }}
        <div class="secondary-description">{{ 'INBOX.WEBCHAT.SETTINGS.ENABLED_DESCRIPTION' | translate }}</div>
      </div>
    </div>
    <button mat-flat-button color="primary" (click)="webChatCardRedirect()">
      {{
        created
          ? ('INBOX.WEBCHAT.SETTINGS.CONFIGURE_WEBCHAT' | translate)
          : ('INBOX.WEBCHAT.SETTINGS.SETUP_WEBCHAT' | translate)
      }}
    </button>
  </mat-card-content>
</mat-card>
